module.exports = __webpack_public_path__ + "img/sx.c81d760d.jpg";